/**
 * @generated SignedSource<<4d9a1d85d7c40f3ed361241803f5d13f>>
 * @relayHash ce0a1fcea73bbb6488d416c80ab59886
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 754d2cc38a760c8dc14a95e414fd026f8971c0689eecc44075d74dfb41db1a60

import type { PreloadableConcreteRequest } from 'relay-runtime';
import type { CaseNoteEditPageQuery } from './CaseNoteEditPageQuery.graphql';

const node: PreloadableConcreteRequest<CaseNoteEditPageQuery> = {
  "kind": "PreloadableConcreteRequest",
  "params": {
    "id": "754d2cc38a760c8dc14a95e414fd026f8971c0689eecc44075d74dfb41db1a60",
    "metadata": {},
    "name": "CaseNoteEditPageQuery",
    "operationKind": "query",
    "text": null
  }
};

export default node;
